import "./ContentHeader.css";

function ContentHeader({children}) {
    return (
        <div className={"content-header"}>{children}</div>
    );
}

export default ContentHeader;